import React from "react";

const StarFill = ({style = {}, size = "36", className = "", fill = "#73788B", viewBox = "0 0 36 36"}) => (
    <svg
        width={size}
        style={style}
        height={size}
        viewBox={viewBox}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={`${className || ""}`}
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >
      <path className="u_fill" d="M18 27.726l-9.888 5.496 2.208-11.037L2 14.545l11.253-1.326L18 3l4.747 10.219L34 14.544l-8.32 7.64 2.208 11.038L18 27.726z"
          fill={fill}
      />
    </svg>
);

export default StarFill;
